import { render, staticRenderFns } from "./doc_select.vue?vue&type=template&id=28ec7189&scoped=true"
import script from "./doc_select.vue?vue&type=script&lang=js"
export * from "./doc_select.vue?vue&type=script&lang=js"
import style0 from "./doc_select.vue?vue&type=style&index=0&id=28ec7189&prod&lang=css"
import style1 from "./doc_select.vue?vue&type=style&index=1&id=28ec7189&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28ec7189",
  null
  
)

export default component.exports